import React, { useState, useEffect } from "react";

import Counter from "./Counter";
import Drawer from "./Drawer";
import NonResidentTicketOptions from "./NonResidentTicketOptions";

const MemberTicket = (props) => {
    const {memberInfo, selectedMemberTickets, setSelectedMemberTickets, selectedTime, ticketType, ticketAmount} = props;
    const [isChecked, setIsChecked] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    // update selectedMemberTickets amounts apart from counters alone
    useEffect(() => {
        if (isChecked && ticketAmount == 1) {
            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, [ticketType]: 1}));
        } else if (!isChecked && ticketAmount == 1) {
            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, [ticketType]: 0}));
        }

        if (!isChecked && ticketAmount !== 1) {
            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, [ticketType]: 0}));
        }
    }, [isChecked]);

    // uncheck counters if selectedTime changes
    useEffect(() => {
        setIsChecked(false);
    }, [selectedTime]);

    // uncheck and zero out based on restrictions
    useEffect(() => {
        // individual through dual plus
        if (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && ['Member Youth', 'Member Child', 'Member Guest'].includes(ticketType) && selectedMemberTickets['Member Adult'] == 0) {
            if (selectedMemberTickets['Member Youth'] != 0) {
                setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Youth']: 0}))
            }
            
            if (selectedMemberTickets['Member Child'] != 0) {
                setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Child']: 0}))
            }

            if (selectedMemberTickets['Member Guest'] != 0) {
                setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest']: 0}))
            }

            setIsDisabled(true);
        }

        // family and up
        else if (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && ['Member Guest'].includes(ticketType) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0)) {
            if (selectedMemberTickets['Member Guest'] != 0) {
                setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest']: 0}))
            }

            setIsDisabled(true);
        }
        
        else {
            setIsDisabled(false)
        }
    }, [selectedMemberTickets]);


    return (
        <div className={`member-ticket-selector__option ${(ticketType == 'Member Guest') ? 'member-ticket-selector__option--last' : ''}`}>
            <div className="fieldgroup fieldgroup--checkbox">
                <input
                    type="checkbox"
                    id={ticketType}
                    name={ticketType}
                    disabled={isDisabled}
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                />
                <label for={ticketType}>
                    {ticketType}
                    {ticketType == 'Member Adult' && <div>Ages 18 &amp; over</div>}
                    {ticketType == 'Member Youth' && <div>Ages 4 - 18</div>}
                    {ticketType == 'Member Child' && <div>Ages 3 &amp; under</div>}
                </label>
            </div>
            {ticketAmount !== 1 && isChecked &&
                <div className="fieldgroup fieldgroup--checkbox">
                    <Counter
                        inputLimit={ticketAmount}
                        valueKey={ticketType}
                        valueObject={selectedMemberTickets}
                        setValue={setSelectedMemberTickets}
                    />
                </div>
            }
        </div>
    )
}

const MemberTicketSelector = (props) => {
    const {isWAResident, isMember, todaysTicketData, seats, selectedTime, selectedTimeIndex, maxTickets, memberInfo, memberOptions, memberRestrictions, selectedTickets, setSelectedTickets, selectedMemberTickets, setSelectedMemberTickets} = props;

    const MemberGuestAdultPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Guest Adult');
    const MemberGuestYouthPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Member Guest Youth');

    function handleHalfPricedTicketSelections() {
        const firstSelectValue = document.querySelector('.first-ticket').value;
        const secondSelectValue = document.querySelector('.second-ticket').value;

        // clear half priced options
        setSelectedMemberTickets(selectedMemberTickets => ({
            ...selectedMemberTickets, 'Member Guest Adult': 0, 'Member Guest Youth': 0
        }));

        // check selects to apply choices
        if (firstSelectValue.length) {
            setSelectedMemberTickets(selectedMemberTickets => ({
                ...selectedMemberTickets, [firstSelectValue]: selectedMemberTickets[firstSelectValue] += 1
            }));
        }
        if (secondSelectValue.length) {
            setSelectedMemberTickets(selectedMemberTickets => ({
                ...selectedMemberTickets, [secondSelectValue]: selectedMemberTickets[secondSelectValue] += 1
            }));
        }
    }

    const selectedMemberTicketsAmount = selectedMemberTickets
        ? Object.values(selectedMemberTickets).reduce((total, quantity) => total + quantity, 0)
        : 0;

    const selectedNonMemberTicketsAmount = selectedTickets
        ? Object.values(selectedTickets).reduce((total, quantity) => total + quantity, 0)
        : 0;

    const nonMemberMaxTickets = Math.max(maxTickets - selectedMemberTicketsAmount, 0);
    
    const getMemberTicketAmount = (ticketType, quantity) => maxTickets
        ? Math.min(maxTickets 
            - selectedMemberTicketsAmount
            + (selectedMemberTickets[ticketType] || 0),
            quantity
        )
        : quantity;

    // reset half priced select fields when selectedTime changes
    useEffect(() => {
        document.querySelector('.first-ticket').selectedIndex = 0;
        document.querySelector('.second-ticket').selectedIndex = 0;
    }, [selectedTime]);

    // rest half priced select fields based on level restrictions
    useEffect(() => {
        // individual through dual plus
        if (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && selectedMemberTickets['Member Adult'] == 0) {            
            document.querySelector('.first-ticket').selectedIndex = 0;
            document.querySelector('.second-ticket').selectedIndex = 0;

            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest Adult']: 0}))
            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest Youth']: 0}))
        }

        // family and up
        if (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0)) {
            document.querySelector('.first-ticket').selectedIndex = 0;
            document.querySelector('.second-ticket').selectedIndex = 0;

            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest Adult']: 0}))
            setSelectedMemberTickets(selectedMemberTickets => ({...selectedMemberTickets, ['Member Guest Youth']: 0}))
        }
    }, [selectedMemberTickets]);

    return (
        <div className="member-ticket-selector">
            <h4>Who's Coming?</h4>
            <h5>{memberInfo.primaryCardHolder.membershipCategory}</h5>
            <Drawer title="What does my membership include?">
                <ul style={{marginTop: 0}}>
                    {memberOptions?.current?.benefits?.map(benefit => {
                        return <li>{benefit.description}</li>;
                    })}
                </ul>
            </Drawer>

            {/* Message for Individual through Dual Plus levels */}
            {['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && <>
                <p>All membership levels include the benefit of two half-price guest tickets per day. To use this benefit, select the "Member Guest Adult" and/or "Member Guest Youth" ticket types. Members with "Plus" levels can reserve their free flexible guest by selecting the "Member Guest" ticket type. All member guests must be accompanied by a covered member when visiting the Aquarium.</p>
                <p>An adult ticket must be added before child tickets can be added. Kids ages 3 and under require tickets—but they're free!</p>
            </>}

            {/* Message for Family and higher levels */}
            {!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && <>
                <p>All membership levels include the benefit of two half-price guest tickets per day. To use this benefit, select the "Member Guest Adult" and/or "Member Guest Youth" ticket types. Members with "Plus" levels can reserve their free flexible guest by selecting the "Member Guest" ticket type. All member guests must be accompanied by a covered member when visiting the Aquarium.</p>
                <p>A Member Adult, Member Youth, or Member Child ticket must be selected before the other ticket types are available to select. Kids ages 3 and under require tickets—but they're free!</p>
            </>}

            <div className="member-ticket-selector__options">
                {memberRestrictions != null && memberRestrictions.map(item => {
                    if (item.quantity == 0 || item.applies_to_name == 'Member Guest Adult' || item.applies_to_name == 'Member Guest Youth') {
                        return;
                    }
                    return <MemberTicket
                        memberInfo={memberInfo}
                        ticketType={item.applies_to_name}
                        ticketAmount={getMemberTicketAmount(item.applies_to_name, item.quantity)}
                        selectedMemberTickets={selectedMemberTickets}
                        setSelectedMemberTickets={setSelectedMemberTickets}
                        selectedTime={selectedTime}
                    />
                })}
            </div>
            <div className="member-ticket-selector__more-options">
                <Drawer title="Add your 2 half-priced tickets!">
                    <div className="form-columns">
                        <div className="fieldgroup fieldgroup--select">
                            <label>First ticket</label>
                            <select className="first-ticket" onChange={() => handleHalfPricedTicketSelections()}>
                                <option value="">None</option>
                                <option
                                    value="Member Guest Adult"
                                    disabled={
                                        (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && selectedMemberTickets['Member Adult'] == 0)
                                        ||
                                        (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0))
                                    }
                                >
                                    Member Guest Adult - ${MemberGuestAdultPrice.length > 0 && MemberGuestAdultPrice[0].price.toFixed(2)}
                                </option>
                                <option
                                    value="Member Guest Youth"
                                    disabled={
                                        (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && selectedMemberTickets['Member Adult'] == 0)
                                        ||
                                        (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0))
                                    }
                                >
                                    Member Guest Youth - ${MemberGuestYouthPrice.length > 0 && MemberGuestYouthPrice[0].price.toFixed(2)}
                                </option>
                            </select>
                        </div>
                        <div className="fieldgroup fieldgroup--select">
                            <label>Second ticket</label>
                            <select className="second-ticket" onChange={() => handleHalfPricedTicketSelections()}>
                                <option value="">None</option>
                                <option
                                    value="Member Guest Adult"
                                    disabled={
                                        (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && selectedMemberTickets['Member Adult'] == 0)
                                        ||
                                        (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0))
                                    }
                                >
                                    Member Guest Adult - ${MemberGuestAdultPrice.length > 0 && MemberGuestAdultPrice[0].price.toFixed(2)}
                                </option>
                                <option
                                    value="Member Guest Youth"
                                    disabled={
                                        (['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && selectedMemberTickets['Member Adult'] == 0)
                                        ||
                                        (!['Individual', 'Individual Plus', 'Dual', 'Dual Plus'].includes(memberInfo.primaryCardHolder.membershipCategory) && (selectedMemberTickets['Member Adult'] == 0 && selectedMemberTickets['Member Youth'] == 0 && selectedMemberTickets['Member Child'] == 0))
                                    }
                                >
                                    Member Guest Youth - ${MemberGuestYouthPrice.length > 0 && MemberGuestYouthPrice[0].price.toFixed(2)}
                                </option>
                            </select>
                        </div>
                    </div>
                </Drawer>
                {!!(!maxTickets || nonMemberMaxTickets > 0) &&
                    <Drawer title="Need additional tickets?">
                        <div className="guest-ticket-selector__options">
                            <NonResidentTicketOptions
                                isWAResident={isWAResident}
                                isMember={false}
                                maxTickets={nonMemberMaxTickets}
                                todaysTicketData={todaysTicketData}
                                seats={seats}
                                selectedTime={selectedTime}
                                selectedTimeIndex={selectedTimeIndex}
                                selectedTickets={selectedTickets}
                                setSelectedTickets={setSelectedTickets}
                            />
                        </div>
                    </Drawer>
                }
            </div>
        </div>
    )
};

export default MemberTicketSelector;